module.exports = __webpack_public_path__ + "static/media/Monje.d42b7879.jpg";